import React, { FC } from 'react';
import './BirthWishForm.css';
import {
	RequiredNote,
	TextAreaField,
	BirthWishPreview,
	CheckBoxField,
	DomainFormProps
} from '@/Shared';


/**
 * =====================================================
 * Component: BirthWishForm
 * =====================================================
 *
 *
 * Domain-specific form UI for BirthWish.
 * Mounted inside GenericDomainForm.
 *
 * Responsibilities:
 * - Render birthWish fields
 * - Use data from formVM (options, values)
 *
 * No permissions, no loading, no orchestration logic here.
 *
 * Author: Samano CASTRE
 * Date: February 15, 2026
 */
const BirthWishForm: FC<DomainFormProps> = ({
	domainFormHook,
	formikProps,

}) => {

	const { values } = formikProps;
	const { entityFormVM } = domainFormHook;

	/**
	 * =====================================================
	 * Main Form Rendering
	 * =====================================================
	 *
	 * Fieldsets organize the form into logical sections for clarity.
	 */

	return (

		<div className="fieldset-wrapper">
			<fieldset className='width-30'>
				<legend>Anniversaire : ({entityFormVM.birthDay})</legend>
				<TextAreaField
					name="message"
					label='Messsage (min : 10, max : 500)'
					placeholder={"Saisir le message d'anniversaire"}
					rows={15}
				/>
				<CheckBoxField
					label="Confirmer l'envoi du message."
					name='valid'
				/>
				<RequiredNote />
			</fieldset>
			<fieldset>
				<legend>Prévisualisation</legend>
				<BirthWishPreview
					contactName={entityFormVM.contactName}
					message={values.message}
				/>
			</fieldset>
		</div>

	);
}
export default BirthWishForm;